export default "__VITE_ASSET__BWxxQ$L5__"